// index.tsx - PayPal 관련 코드 전부 삭제
import ReactDOM from "react-dom/client";
import "src/styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "src/locales/i18n";
import { store } from "src/store/app/store";
import { Provider } from "react-redux";
import { ProSidebarProvider } from "react-pro-sidebar";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <div className="app-container">
    <QueryClientProvider client={queryClient}>
      <ProSidebarProvider>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </ProSidebarProvider>
    </QueryClientProvider>
  </div>
);

reportWebVitals();
